import React from 'react';
import {
  BodyText,
  Button,
  Icon,
  IconSize,
  IconType,
  INavigationItemProps,
  NavigationItem,
  Spinner,
  SpinnerSize,
  Tooltip,
} from 'ui-toolkit';
import '../../scss/_cd-navigation.scss';

export interface ICdNavigation {
  active: INavigationItemProps;
  linkItems: INavigationItemProps[];
  loading: boolean;
  ownerId: string;
  saved?: boolean;
  showSectionNav?: boolean;
  hasEditPermission: boolean;

  onGenerate(): void;
  onSave(): void;
}

export default class CdNavigation extends React.Component<ICdNavigation> {
  public static defaultProps: Partial<ICdNavigation> = {
    saved: false,
  };

  constructor(props: ICdNavigation) {
    super(props);
    this.generate = this.generate.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { active, linkItems, showSectionNav, hasEditPermission } = this.props;

    return (
      <div className="cd-navigation">
        <div className="cd-navigation__links">
          {showSectionNav ? (
            <>
              {linkItems.map((link, index) => (
                <NavigationItem key={index} {...link} isActive showUnderline={link.text === active.text} />
              ))}
            </>
          ) : null}
        </div>
        <div className="cd-navigation__actions">
          {this.props.loading ? <Spinner size={SpinnerSize.small} /> : null}
          {this.props.saved ? <Icon type={IconType.Check} size={IconSize.Small} /> : null}
          {!hasEditPermission ? (
            <Tooltip
              placement={'auto'}
              trigger={'hover'}
              tooltipContent={<BodyText>You do not have the necessary permissions to edit this</BodyText>}
            >
              <Button disabled={true} intent="secondary" onClick={this.save}>
                Save Update
              </Button>
            </Tooltip>
          ) : (
            <Button intent="secondary" onClick={this.save}>
              Save Update
            </Button>
          )}
          <Button intent="primary" onClick={this.generate}>
            Generate PDF
          </Button>
        </div>
      </div>
    );
  }

  protected generate() {
    this.props.onGenerate();
  }

  protected save() {
    this.props.onSave();
  }
}
